/**
 * This reducer is used for fetching shipping methods
 */
import {
    GET_SHIP_TO_ADDRESS,
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_ADDRESS_FAILURE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    shipToAddress: {},
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const shipToAddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIP_TO_ADDRESS:
            return {
                ...state,
                shipToAddress: [],
                loading: true,
            };
        case GET_SHIP_TO_ADDRESS_SUCCESS:
            return {
                ...state,
                shipToAddress: {
                    ...state.shipToAddress,
                    ...action.payload,
                },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SHIP_TO_ADDRESS_FAILURE:
            return {
                ...state,
                shippingMethods: {},
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };

        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentShipToAddressKey',
        storage: storage,
    },
    shipToAddressReducer
);
